const MOBILE_QUERY = '(max-width: 749px)';
const TITLE_SELECTOR = '.product-details .product-title-block';

const mediaQuery = window.matchMedia(MOBILE_QUERY);
let resizeObserver;

function numberFromCss(value, fallback) {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

function getTextElement(block) {
  return block.firstElementChild || block;
}

function resetTitle(block) {
  const textElement = getTextElement(block);
  textElement.style.removeProperty('font-size');
  textElement.style.removeProperty('--product-title-fit-size');
  textElement.style.removeProperty('white-space');
  textElement.style.removeProperty('text-wrap');
  textElement.style.removeProperty('overflow-wrap');
}

function fitTitle(block) {
  const textElement = getTextElement(block);

  if (!mediaQuery.matches) {
    resetTitle(block);
    return;
  }

  const availableWidth = Math.floor(block.getBoundingClientRect().width);
  if (availableWidth <= 0) return;

  const computed = window.getComputedStyle(textElement);
  const baseSize = numberFromCss(block.dataset.productTitleBaseSize, numberFromCss(computed.fontSize, 32));
  block.dataset.productTitleBaseSize = String(baseSize);

  const minSize = numberFromCss(computed.getPropertyValue('--product-title-mobile-fit-min'), 15);
  const maxSize = Math.min(baseSize, numberFromCss(computed.getPropertyValue('--product-title-mobile-fit-max'), baseSize));

  textElement.style.whiteSpace = 'nowrap';
  textElement.style.textWrap = 'nowrap';
  textElement.style.fontSize = `${maxSize}px`;

  if (textElement.scrollWidth <= availableWidth) return;

  // Scale from one measured width instead of repeatedly alternating style
  // writes and layout reads. A single correction handles subpixel rounding.
  const measuredWidth = textElement.scrollWidth;
  let fittedSize = Math.max(minSize, maxSize * (availableWidth / measuredWidth));
  textElement.style.fontSize = `${fittedSize}px`;

  const correctedWidth = textElement.scrollWidth;
  if (correctedWidth > availableWidth && fittedSize > minSize) {
    fittedSize = Math.max(minSize, fittedSize * (availableWidth / correctedWidth));
    textElement.style.fontSize = `${fittedSize}px`;
  }

  // Very long titles can still overflow at the minimum fitted size.
  // In that case, prefer a readable two-line title over shrinking the text further.
  if (textElement.scrollWidth > availableWidth + 1) {
    const wrappedSize = Math.max(minSize, Math.min(maxSize, baseSize * 0.9));
    textElement.style.fontSize = `${wrappedSize}px`;
    textElement.style.whiteSpace = 'normal';
    textElement.style.textWrap = 'balance';
    textElement.style.overflowWrap = 'anywhere';
  }
}

function fitAllTitles() {
  document.querySelectorAll(TITLE_SELECTOR).forEach(fitTitle);
}

function observeTitles() {
  if (resizeObserver) resizeObserver.disconnect();
  resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      fitTitle(entry.target);
    }
  });

  document.querySelectorAll(TITLE_SELECTOR).forEach((block) => resizeObserver.observe(block));
}

function boot() {
  observeTitles();
  fitAllTitles();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

window.addEventListener('resize', fitAllTitles, { passive: true });
mediaQuery.addEventListener('change', fitAllTitles);

if (document.fonts?.ready) {
  document.fonts.ready.then(fitAllTitles);
}
